export const MUTATION_TYPES = {
  SET_EVALUATIONS: 'set-evaluations',
  SET_CURRENT_EVALUATION_ID: 'set-current-evaluation-id',
};

export const mutations = {
  [MUTATION_TYPES.SET_EVALUATIONS](state, evaluations) {
    state.evaluations = evaluations;
  },

  [MUTATION_TYPES.SET_CURRENT_EVALUATION_ID](state, id) {
    state.currentEvaluationId = id;
  },
};
